// extracted by mini-css-extract-plugin
export default {"entityField":"auditsList_entityField__Z+6jH"};